
{
  "title": "Confirm",
  "message": "Would you really like to take this action?",
  "actions": {
    "confirm": "Confirm",
    "cancel": "Cancel"
  }
}
